export default __webpack_public_path__ + "static/media/galleryExport.0ed9578b.svg";